export default {
    error: {
        nestedStyles: function (command) {
            if (CKEDITOR.wixDocumentServices) {
                //send bi event, as defined in santa editor file errors.json
                CKEDITOR.wixDocumentServices.bi.error({
                    errorName: 'TEXT_NESTED_STY{LES',
                    errorCode: 12901,
                    severity: 'recoverable',
                    params: {
                        p1: 'command'
                    }
                }, {
                    command: command
                });
            } else {
                console.log('there shouldn\'t be nested styles of the same type'); //eslint-disable-line no-console
            }
        },
        unableToRestoreSelection: function () {
            if (CKEDITOR.wixDocumentServices) {
                //send bi event, as defined in santa editor file errors.json
                CKEDITOR.wixDocumentServices.bi.error({
                    errorName: 'TEXT_UNABLE_TO_RESTORE_SELECTION',
                    errorCode: 12902,
                    severity: 'error'
                });
            } else {
                console.log('unable to restore original selection'); //eslint-disable-line no-console
            }
        }
    }
};
